export default __webpack_public_path__ + "fc9295a4651c56d5b4e8c3aa13a93208.svg";